// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3tfxe","inputWrap":"Table_inputWrap__1BIDN","col":"Table_col__ZCA86","bmiTooltip":"Table_bmiTooltip__1hhfA"};